/*
 * -----------------------------------------------------------------------
 *  <copyright file="refresh-component/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React, { useEffect, useState } from 'react';
import Loading from '@components/core/loading';

const RefreshComponent = ({ dataChange, children }: { dataChange: any; children: JSX.Element }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, [dataChange]);

    if (loading) return <Loading />;

    return children;
};

export default RefreshComponent;
